/* eslint-disable @typescript-eslint/no-explicit-any */
import gql from 'graphql-tag';

export default class PersonService {
  async getPersona(vue,id) {
    const sql = gql` 
      query{
        getPersona(id:${id}){
          nombres,num_doc,email,sexo,diestro,tipo
          iddepartamento,pri_apellido,seg_apellido,
          domicilio, telefono1,telefono2, est_civil,
          idinstitucion,idpais,profesiones{id},
          grados{id nombre titulo}
        }
      }
    `
    return await vue.$apollo.query({ query: sql }).then((d)=>d).catch((e)=>e)
  }

  async updatePersona(vue, input) {
    const sql = gql` 
      mutation{
        updatePersona(input:${window.stringifyObject(input)}){
          ok, errors{message}
        }
      }
    `
    return await vue.$apollo.mutate({ mutation: sql }).then((d)=>d).catch((e)=>e)
  }

  async getInstituciones(vue) {
    const sql = gql` 
      query{
        getInstituciones(estado:true){
          id, nombre, tipo, convenio, abreviatura
        }
      }
    `
    return await vue.$apollo.query({ query: sql }).then((d)=>d).catch((e)=>e)
  }

  async getProfesiones(vue) {
    const sql = gql` 
      query{
        getProfesiones(estado:true){
          id, nombre 
        }
      }
    `
    return await vue.$apollo.query({ query: sql }).then((d)=>d).catch((e)=>e)
  }

  async getDepartamentos(vue) {
    const sql = gql` 
      query{
        getDepartamentos {
          id, nombre, extension
        }
      }
    `
    return await vue.$apollo.query({ query: sql }).then((d)=>d).catch((e)=>e)
  }

  async getGrados(vue) {
    const sql = gql` 
      query{
        getGrados {
          id, nombre 
        }
      }
    `
    return await vue.$apollo.query({ query: sql }).then((d)=>d).catch((e)=>e)
  }

  async getPaises(vue) {
    const sql = gql` 
      query{
        getPaises {
          id, nombre 
        }
      }
    `
    return await vue.$apollo.query({ query: sql }).then((d)=>d).catch((e)=>e)
  }
  
}
